import React from 'react'
import PrestacaoPdf from '../components/Contas/PrestacaoPdf'


export const Contas = () => {
    return (
        <>
            <PrestacaoPdf />
        </>
    )
}
